module.exports = __webpack_public_path__ + "static/media/group-copy.15e71f33.png";